import { Form } from 'antd';
import React from 'react';
import { EditableContext } from './types';

interface EditableRowProps {
  index: number;
}
export const EditableRow: React.FC<EditableRowProps> = ({
  index,
  ...props
}) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr key={index} {...props} />
      </EditableContext.Provider>
    </Form>
  );
};
